import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ArtistName = (props) => {
  const { track, link: linkArtistName } = props;
  const artistName = track.artist || "";
  let artistNameEncode = encodeURIComponent(artistName); // .replace(/ /g, "+").replace(/&/g, "%26"));
  //artistNameEncode = encodeURIComponent(artistNameEncode);

  if (linkArtistName) {
    return (
      <Link to={`/artist/${artistNameEncode}`}>
        <span>{artistName}</span>
      </Link>
    );
  } else {
    return <span>{artistName}</span>;
  }
};

ArtistName.propTypes = {
  track: PropTypes.object.isRequired,
  link: PropTypes.bool,
};

ArtistName.defaultProps = {
  link: true,
};

export default ArtistName;
